module.exports = __webpack_public_path__ + "static/img/Bronze.c5f82b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Bronze.svg
// module id = ywmn
// module chunks = 35